


import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {formDetails} from "../model/course";
import {Observable} from "rxjs/Observable";
import {CoursesService} from "./courses.service";



@Injectable()
export class CourseResolver implements Resolve<formDetails> {

    constructor(private coursesService:CoursesService) {

    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<formDetails> {
        return this.coursesService.findCourseById(route.params['id']);
    }

}

